import { get } from 'lodash-es';
import StatusCodes from 'http-status-codes';
import { getMountRoot } from '@is24at/react-utils';
import { EMPTY_OBJECT } from '@is24at/react-constants';
import { htmlMetaGenerated } from 'components/HtmlMeta/modules/htmlMeta';
import { universalReplaceHistory } from 'utils/utils';
import {
  buildPrettyUrlFromAccount,
  isInvalidPrettyExposeUrl,
  isPrettyExposeRoute,
  urlHasTrailingSlash,
  parseCwidFromUrlParams,
} from 'core/prettyUrlsExpose';
import { universalFetch as fetch } from 'core/fetch';
// import { PSA_API_PROFILE } from 'core/configs';
import { fetchProperties } from '../components/RealtorProperties/modules/realtorProperties';
import { fetchRealtorData, fetchRealtorFailure } from './expose';
import generateHtmlMeta from './exposeHtmlMetaTransformer';

const isNotFound = (err: any) =>
  get(err, 'response.status') === StatusCodes.NOT_FOUND;

export const MAX_NO_OF_PROPERTIES = 10;

export const fetchRealtorAndGenerateHtmlMeta = async ({
  store: { dispatch, getState },
  match: { params, url },
  helpers,
  history: { replace } = EMPTY_OBJECT,
}: any) => {
  try {
    const cwid = parseCwidFromUrlParams(params);
    if (!cwid) {
      return dispatch(fetchRealtorFailure(StatusCodes.NOT_FOUND));
    }
    const { result: isDeveloper } = await fetch(
      `${getMountRoot().replace(/\/?$/, '/')}isDeveloper/${cwid}`,
    );

    if (isDeveloper) {
      return dispatch(fetchRealtorFailure(StatusCodes.NOT_FOUND));
    }
    const realtorData = await fetchRealtorData(cwid, getState())(dispatch);
    const shouldRedirect =
      (isPrettyExposeRoute(params) &&
        isInvalidPrettyExposeUrl(params, realtorData)) ||
      !urlHasTrailingSlash(url);
    if (shouldRedirect) {
      return universalReplaceHistory(
        replace,
        get(helpers, 'redirectIntent'),
        buildPrettyUrlFromAccount(realtorData),
      );
    }
    const htmlMeta = generateHtmlMeta(realtorData);
    dispatch(htmlMetaGenerated(htmlMeta));
    return fetchProperties({
      accountCwid: cwid,
      size: MAX_NO_OF_PROPERTIES.toString(),
    })(dispatch);
  } catch (e) {
    return isNotFound(e)
      ? dispatch(fetchRealtorFailure(StatusCodes.NOT_FOUND))
      : dispatch(fetchRealtorFailure(StatusCodes.BAD_REQUEST));
  }
};
